import {
  Entity,
  entityEnvelopeSchemaValidator,
  EntityMeta,
} from '@backstage/catalog-model';
import schema from '../schema/Release.v1alpha1.schema.json';
import { generateAjvJsonSchemaValidator } from '../utils';
import { EntityAndBranch } from '../builder';
import { DeploymentUnitStatus } from '../deployment';

declare interface ReleaseEntityV1alpha1 extends Entity {
  apiVersion: 'agilelab.it/v1alpha1';
  kind: 'Release';
  metadata: EntityMeta & {
    name: string;
    projectKind?: string;
    projectName: string;
    dataProductName?: string;
    version: string;
    createdAt: string;
    repoUrl: string;
    releaseLocation: string;
    branch: string;
    isSnapshot: boolean;
    tags?: string[];
    committedAt?: string;
    deployedAt?: string;
    releasedAt?: string;
    creatorRef?: string;
    createdFrom?: EntityAndBranch[];
    /**
     * The release features a different descriptor for each environment in this list (persisted in `descriptor.<environment>.yaml`).
     * If an environment is not present in the list, the default descriptor applies (`descriptor.yaml`).
     */
    environments?: string[];
  };
}

export type { ReleaseEntityV1alpha1 };
export type { ReleaseEntityV1alpha1 as ReleaseEntity };
export type DeployVersionStatus = {
  environment: string;
  status: DeploymentUnitStatus;
  version?: string;
};
export type ReleaseAndDeployments = ReleaseEntityV1alpha1 & {
  deployments: DeployVersionStatus[];
};

export const applyReleaseEntityV1alpha1 =
  entityEnvelopeSchemaValidator<ReleaseEntityV1alpha1>(schema);

export const releaseEntityV1alpha1Validator =
  generateAjvJsonSchemaValidator(schema);
